// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1-v5I","row":"Node_row__3OUcV","label":"Node_label__3AVjs","footer":"Node_footer__2w5Vg"};